// extracted by mini-css-extract-plugin
module.exports = {"fallback":"antd-pro-components-error-component-index-fallback","eventId":"antd-pro-components-error-component-index-eventId"};